/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_RegionInputs */

const en_live_caption_youtube_region = /** @type {(inputs: Live_Caption_Youtube_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default YouTube region`)
};

const fr_live_caption_youtube_region = /** @type {(inputs: Live_Caption_Youtube_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Région YouTube par défaut`)
};

const de_live_caption_youtube_region = /** @type {(inputs: Live_Caption_Youtube_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard-YouTube-Region`)
};

const it_live_caption_youtube_region = /** @type {(inputs: Live_Caption_Youtube_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regione predefinita di YouTube`)
};

const ru_live_caption_youtube_region = /** @type {(inputs: Live_Caption_Youtube_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Регион YouTube по умолчанию`)
};

const es_live_caption_youtube_region = /** @type {(inputs: Live_Caption_Youtube_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Región predeterminada de YouTube`)
};

const zh_cn2_live_caption_youtube_region = /** @type {(inputs: Live_Caption_Youtube_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube 默认区域`)
};

const ja_live_caption_youtube_region = /** @type {(inputs: Live_Caption_Youtube_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTubeのデフォルト地域`)
};

const hi_live_caption_youtube_region = /** @type {(inputs: Live_Caption_Youtube_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डिफ़ॉल्ट YouTube क्षेत्र`)
};

const pt_pt2_live_caption_youtube_region = /** @type {(inputs: Live_Caption_Youtube_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Região padrão do YouTube`)
};

/**
* | output |
* | --- |
* | "Default YouTube region" |
*
* @param {Live_Caption_Youtube_RegionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_region = /** @type {((inputs?: Live_Caption_Youtube_RegionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_RegionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_youtube_region(inputs)
	if (locale === "de") return de_live_caption_youtube_region(inputs)
	if (locale === "it") return it_live_caption_youtube_region(inputs)
	if (locale === "ru") return ru_live_caption_youtube_region(inputs)
	if (locale === "es") return es_live_caption_youtube_region(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_youtube_region(inputs)
	if (locale === "ja") return ja_live_caption_youtube_region(inputs)
	if (locale === "hi") return hi_live_caption_youtube_region(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_youtube_region(inputs)
	return en_live_caption_youtube_region(inputs)
});